// Validar si el navegador y la version son compatibles con la aplicacion
export const validateBrowser = (browser: string, version: number): boolean => {
    const browserVersion = browserVersions[browser] || browserVersions['Other']

    if (browserVersion) return version >= browserVersion

    return false
}

// Versiones minimas de los navegadores compatibles
const browserVersions = {
    'MS-Edge-Chromium': 80,
    Chrome: 80,
    Firefox: 72,
    Safari: 13,
    Opera: 67,
    IE: 11,
    Edge: 80,
    'Samsung Internet': 10.1,
    Other: 0,
}

